module.exports = __webpack_public_path__ + "img/prize-02.56baf863.png";